module.exports = __webpack_public_path__ + "img/vegetable-asparagus-350x184.71961374.jpg";